export default __webpack_public_path__ + "static/media/example-src.dd395eab.jpg";